<template>
  <div class="container">
    <p></p>
    <div class="titulo text-center">
      <h2><strong>GESTIÓN DE UBICACIONES</strong></h2>
    </div>
    <p></p>
    <div class="d-flex justify-content-between mb-3">
      <button v-if="!isFormVisible" @click="showForm" class="btn btn-success">
        <i class="bi bi-geo-alt"></i> Agregar Ubicación
      </button>

      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div class="table-container">
      <table class="table table-striped table-hover table-bordered dark">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ubicacion in paginatedUbicaciones" :key="ubicacion.Id_ubicacion">
            <td>{{ ubicacion.Id_ubicacion }}</td>
            <td>{{ ubicacion.Nombre }}</td>
            <td>
              <button @click="editUbicacion(ubicacion)" class="btn btn-link">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button
                @click="deleteUbicacion(ubicacion.Id_ubicacion)"
                class="btn btn-link1"
              >
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>

    <div v-if="isFormVisible" class="form-container">
      <h3>{{ isEditing ? "Editar Ubicación" : "Agregar Ubicación" }}</h3>
      <form @submit.prevent="isEditing ? submitEditForm() : submitForm()">
        <div class="form-group">
          <label for="nombre">Nombre</label>
          <input
            v-model="ubicacion.Nombre"
            type="text"
            id="nombre"
            class="form-control"
            required
          />
        </div>
        <p></p>
        <button type="submit" class="btn btn-primary me-2">
          {{ isEditing ? "Actualizar" : "Guardar" }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancelForm">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      lista_ubicaciones: [],
      ubicacion: {
        Id_ubicacion: null,
        Nombre: "",
      },
      isFormVisible: false,
      isEditing: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredUbicaciones() {
      return this.lista_ubicaciones.filter((ubicacion) => {
        const searchString = `${ubicacion.Id_ubicacion} ${ubicacion.Nombre}`.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedUbicaciones() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredUbicaciones.slice(startIndex, startIndex + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredUbicaciones.length / this.itemsPerPage);
    },
  },
  methods: {
    // Obtener ubicaciones
    getUbicaciones() {
      axios
        .get(this.$backendUrl+ "/index.php/ubicaciones/lista_completa")
        .then((response) => {
          this.lista_ubicaciones = response.data;
        })
        .catch((error) => {
          Swal.fire("Error", "Error al obtener ubicaciones.", "error");
          console.error("Error al obtener ubicaciones:", error);
        });
    },

    // Validar formulario
    validateForm() {
      if (!this.ubicacion.Nombre.trim()) {
        Swal.fire("Advertencia", "El nombre es obligatorio.", "warning");
        return false;
      }
      return true;
    },

    // Enviar formulario para agregar ubicación
    submitForm() {
      if (this.validateForm()) {
        axios
          .post(this.$backendUrl+ "/index.php/ubicaciones/insertar", this.ubicacion)
          .then(() => {
            this.getUbicaciones();
            this.cancelForm();
            Swal.fire("Éxito", "Ubicación agregada correctamente.", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Error al agregar ubicación.", "error");
            console.error("Error al agregar ubicación:", error);
          });
      }
    },

    // Enviar formulario para editar ubicación
    submitEditForm() {
      if (this.validateForm()) {
        axios
          .put(this.$backendUrl+ "/index.php/ubicaciones/actualizar", this.ubicacion)
          .then(() => {
            this.getUbicaciones();
            this.cancelForm();
            Swal.fire("Éxito", "Ubicación actualizada correctamente.", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Error al editar ubicación.", "error");
            console.error("Error al editar ubicación:", error);
          });
      }
    },

    // Eliminar ubicación con confirmación
    deleteUbicacion(id) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.$backendUrl+ "/index.php/ubicaciones/borrar", {
              data: { Id_ubicacion: id },
            })
            .then(() => {
              this.getUbicaciones();
              Swal.fire("Eliminado", "La ubicación ha sido eliminada.", "success");
            })
            .catch((error) => {
              Swal.fire("Error", "Error al eliminar ubicación.", "error");
              console.error("Error al eliminar ubicación:", error);
            });
        }
      });
    },

    // Mostrar formulario para agregar
    showForm() {
      this.isFormVisible = true;
      this.isEditing = false;
      this.resetForm();
    },

    // Mostrar formulario para editar
    editUbicacion(ubicacion) {
      this.isEditing = true;
      this.isFormVisible = true;
      this.ubicacion = { ...ubicacion };
    },

    // Cancelar formulario
    cancelForm() {
      this.isFormVisible = false;
      this.isEditing = false;
      this.resetForm();
    },

    // Resetear formulario
    resetForm() {
      this.ubicacion = {
        Id_ubicacion: null,
        Nombre: "",
      };
    },

    // Cambiar página
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.getUbicaciones();
  },
};
</script>


<style scoped>
.table-container {
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  margin-top: 20px;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349;
  color: white;
  font-size: 18px;
  padding: 15px;
}

.btn-link {
  color: #2fc1f6;
  font-size: 150%;
  border: none;
}

.btn-link:hover {
  color: #ce13a2;
}

.btn-link1 {
  color: red;
  font-size: 150%;
  border: none;
}
</style>
